import React from 'react';
import {
    SingleFieldList,
    ChipField,
    ReferenceManyField,
    TextField
} from 'react-admin';
import CustomTableShow from './CustomTableShow';

class ProducerShow extends CustomTableShow {

    customHandled(fields, fieldName, fieldList) {
        if (fieldName === 'contactPhone') {

            fieldList.push(<TextField source={fieldName}/>);
            fieldList.push(<ReferenceManyField label={'Wines'} reference={'wines'} target={'producers'}>
                <SingleFieldList>
                    <ChipField source="nameEN" />
                </SingleFieldList>
            </ReferenceManyField>);

            return true;
        }

        return false;
    }
}

export default ProducerShow;